// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCreateSubmission } from '@hooks/mutations/ledger/useSubmission';
import { HolderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Holder';
import { ERR_REQ_HOLDER_SVC, SUC_REQ_HOLDER_SVC } from '../../../../utils/strings';

export const useRequestHolderService = () => {
  const { submit } = useCreateSubmission(
    HolderServiceRequest,
    SUC_REQ_HOLDER_SVC,
    ERR_REQ_HOLDER_SVC,
  );
  return submit;
};
